export default __webpack_public_path__ + "static/media/phone.42ba5712.svg";